import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './Home.css'; // Reutiliza los estilos existentes

/** Rutas públicas exactas sin estrellas (no encajan en prefijos de admin) */
const EXACT_PATHS_WITHOUT_STARS = ['/carrito', '/lista-mayorista'];

/**
 * Prefijos de panel de administración / staff (alineado con Footer.js — isAdminRoute).
 * Incluye /admin vía pathname.startsWith('/admin').
 */
const ADMIN_BACKOFFICE_PREFIXES = [
  '/subscriptores',
  '/editor-masivo',
  '/historial-ventas',
  '/analiticas',
  '/local',
  '/configuracion-descuentos',
  '/gestion-stock',
  '/balance',
  '/costo-envios',
  '/factory',
  '/newsletter',
  '/facturador',
];

function shouldHideAnimatedStars(pathname) {
  if (!pathname) return false;
  if (EXACT_PATHS_WITHOUT_STARS.includes(pathname)) return true;
  if (pathname.startsWith('/admin')) return true;
  return ADMIN_BACKOFFICE_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}

const AnimatedBackground = () => {
  const { pathname } = useLocation();
  const particlesRef = useRef(null);
  const footballBallsRef = useRef([]);
  const hideStars = shouldHideAnimatedStars(pathname);

  // Partículas flotantes
  useEffect(() => {
    if (hideStars) return;
    const createParticles = () => {
      if (particlesRef.current) {
        particlesRef.current.innerHTML = '';
        for (let i = 0; i < 30; i++) {
          const particle = document.createElement('div');
          particle.className = 'particle';
          particle.style.left = Math.random() * 100 + '%';
          particle.style.animationDelay = Math.random() * 15 + 's';
          particle.style.animationDuration = (Math.random() * 10 + 15) + 's';
          particlesRef.current.appendChild(particle);
        }
      }
    };
    const timer = setTimeout(createParticles, 500);
    return () => clearTimeout(timer);
  }, [pathname, hideStars]);

  // Parallax suave al hacer scroll
  useEffect(() => {
    if (hideStars) return;
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const footballBalls = footballBallsRef.current;
      footballBalls.forEach((ball, index) => {
        if (ball) {
          const speed = 0.5 + (index * 0.1);
          ball.style.transform = `translateY(${scrolled * speed}px)`;
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pathname, hideStars]);

  if (hideStars) {
    return null;
  }

  return (
    <>
      <div className="football-background">
        {[...Array(100)].map((_, index) => (
          <div
            key={index}
            className={`football-ball ${['tiny', 'small', 'medium', 'large'][Math.floor(Math.random() * 4)]}`}
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 20}s`,
              animationDuration: `${Math.random() * 20 + 20}s`
            }}
            ref={el => footballBallsRef.current[index] = el}
          />
        ))}
        <div className="shooting-star" style={{ animationDelay: '0s' }} />
        <div className="shooting-star" style={{ animationDelay: '10s' }} />
        <div className="shooting-star" style={{ animationDelay: '10.5s' }} />
      </div>
      <div className="particles" ref={particlesRef}></div>
    </>
  );
};

export default AnimatedBackground; 